export const CATEGORIES = {
  ALL: 'all',
  DIRECT: 'direct',
  COUNTRIES: 'countries',
  INTERESTS: 'interests'
} as const

export const DIRECT_FLIGHTS = 'label_direct_flights' as const

export const ORIGIN = 'origin' as const
export const DESTIN = 'destin' as const

export const DATA_LIST_ITEM = 'data-list-index' as const
export const DATA_LIST_ITEM_WITH_BRACKETS = `[${DATA_LIST_ITEM}]` as const

export const DEFAULT_ORIGIN_CODE = 'RIX'
